import { TableCell, TableFooter, TableRow } from "@mui/material";
import { useContext } from "react";
import UserContext from "../UserContext";
import { dateFormatter } from "../constants";

export const Footer = ({ span }: { span?: number }) => {
    const { user } = useContext(UserContext);

    console.log(user);
    return (
        <TableFooter>
            <TableRow>
                <TableCell colSpan={span ?? 1} sx={{ p: 0 }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "2px 8px",
                            fontSize: "0.7rem",
                            fontWeight: 500,
                        }}
                    >
                        <div>Operator: {user?.name}</div>
                        <div>Timestamp: {dateFormatter.format(new Date())}</div>
                    </div>
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: "0.65rem",
                            padding: "2px",
                        }}
                    >
                        Powered by Zama School
                    </div>
                </TableCell>
            </TableRow>
        </TableFooter>
    );
};
